import React from 'react'
import { useHistory } from 'react-router-dom'
import ROUTES from 'utils/ROUTES'
import MAINTENANCE_TYPE from 'utils/__enums/SuperAdministration/Maintenance'

const DownForMaintenance: React.FC = () => {
  const history = useHistory()

  // Redirect to the maintenance page
  React.useEffect(() => {
    history.push(ROUTES.MaintenanceError, {
      type: MAINTENANCE_TYPE.ALL,
    })
  }, [])

  return null
}

export default DownForMaintenance
